module.exports = __webpack_public_path__ + "static/fonts/righteous-regular.5aaf944.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/righteous-regular.woff
// module id = Y2V/
// module chunks = 1